import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d74dbf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"800px","overflow-y":"auto"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("禁用")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
    width: "1000px",
    title: "设置项目",
    "destroy-on-close": true,
    onOk: _ctx.onSubmit,
    onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setVisible(false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState,
          "label-col": {span: 6},
          "wrapper-col": {span: 14}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "项目标题",
              name: "title",
              rules: _ctx.rules.title
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.title,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.title) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              label: "图片",
              name: "image",
              rules: _ctx.rules.image
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.image,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.image) = $event)),
                  style: {"display":"none"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_form_item_rest, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_UploadComponent, {
                      "on-change": url => _ctx.formState.image = url,
                      "source-url": _ctx.formState.image
                    }, null, 8, ["on-change", "source-url"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              label: "图标",
              name: "tag_image",
              rules: _ctx.rules.tag_image
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.tag_image,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.tag_image) = $event)),
                  style: {"display":"none"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_form_item_rest, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_UploadComponent, {
                      "on-change": url => _ctx.formState.tag_image = url,
                      "source-url": _ctx.formState.tag_image
                    }, null, 8, ["on-change", "source-url"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              label: "是否启用",
              name: "state"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.status,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.status) = $event)),
                  name: "radioGroup"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 1,
                      key: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_a_radio, {
                      value: 0,
                      key: 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "跳转链接",
              name: "link",
              rules: _ctx.rules.link
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.link,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.link) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              label: "排序",
              name: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.sort,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.sort) = $event)),
                  placeholder: "数字越大越往后"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "详情内容",
              name: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.content,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.content) = $event)),
                  style: {"display":"none"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_form_item_rest, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_EditorComponent, {
                      ref: "editorComponentRef",
                      content: _ctx.formState.content
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onOk"]))
}